function urlParamRemove() {
    window.history.replaceState(null, '', window.location.pathname);
}

// clear all url parameters only when it contains form submission data
document.addEventListener('DOMContentLoaded', () => {
    if(window.location.search !== '' && !window.location.search.includes('utm') && (window.location.search.includes('form_type=customer') || window.location.search.includes('customer_posted'))) urlParamRemove();
});